import React from "react";
import StatusCard from "./StatusCard";
import { useAllVisitors } from "../visitor/useAllVisitors";
import EyeSvg from "../../ui/EyeSvg";
import { useBlogs } from "../blog/useBlogs";
import StatusCardBookSvg from "../../ui/StatusCardBookSvg";
import { useUsers } from "../user/useUsers";
import { useAdminComments } from "../comment/useAdminComments";
import UserSvg from "../../ui/UserSvg";
import CommentSvg from "../../ui/CommentSvg";

const StatusCards = () => {
  // 1) visitor card stats
  const { visitors, isLoadingVisitors } = useAllVisitors();
  const totalVisitors = (visitors?.counter / 1000).toFixed(2) + "k";

  // 2) Blog card stats
  let { count, isLoading } = useBlogs();
  let totalBlogs = count;
  totalBlogs = (totalBlogs * 100) / 1000 + "k";

  // 3) User card stats
  const { users, isLoading: isLoadingUsers } = useUsers();

  // 4) Comment card stats
  const { count: totalComments, isLoading: isLoadingComments } = useAdminComments();

  return (
    <div className="grid max-w-full grid-cols-2 gap-x-6 gap-y-6 sm:grid-cols-2 lg:grid-cols-4">
      <StatusCard
        svg={<EyeSvg />}
        title={totalVisitors}
        subTitle={"total views"}
        percetageValue={(visitors?.counter / 10000) * 100}
        isLoading={isLoadingVisitors}
      />
      <StatusCard
        title={totalBlogs}
        subTitle={"total blogs"}
        percetageValue={(count / 1000) * 100}
        svg={<StatusCardBookSvg />}
        isLoading={isLoading}
      />
      <StatusCard
        svg={<UserSvg />}
        title={users?.length ?? 0}
        subTitle={"total users"}
        isLoading={isLoadingUsers}
      />
      <StatusCard
        svg={<CommentSvg />}
        title={totalComments ?? 0}
        subTitle={"total comments"}
        isLoading={isLoadingComments}
      />
    </div>
  );
};

export default StatusCards;
